import { memo, ReactNode } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { useAppSelector } from "@/redux/store";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loginSuccess } = useAppSelector((state) => state.auth);
  const location = useLocation();

  const isAuthenticated = Boolean(user) || loginSuccess;

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/home"
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default memo(ProtectedRoute);
